import BusinessDetailsBadge from './BusinessDetailsBadge.component';

export default BusinessDetailsBadge;